import axios from "../axiosInstance";
import { handleApiResponse } from "../utils";

export const fetchFftLists = ({ isArchived = false, includeDetails = false }) =>
 handleApiResponse(() => axios.get(`/fft/v2/fft-list?is_archived=${isArchived}&include_details=${includeDetails}`), null);

export const fetchFftList = listId => handleApiResponse(() => axios.get(`/fft/v2/fft-list/${listId}`), null);

export const fetchMultipleFftLists = ids => handleApiResponse(() => axios.get(`/fft/v2/fft-list/multiple`, { params: { ids } }));

export const createFftList = requestBody =>
 handleApiResponse(() => axios.post(`/fft/v2/fft-list`, requestBody), "Formulation list created successfully");

export const copyFftList = (listId, requestBody) =>
 handleApiResponse(() => axios.post(`/fft/v2/fft-list/${listId}/copy`, requestBody), "Formulation list copied successfully");

export const updateFftListsService = requestBody =>
 handleApiResponse(() => axios.put(`/fft/v2/fft-list`, requestBody), "Formulation lists updated successfully");

export const updateFftListService = (listId, requestBody) =>
 handleApiResponse(() => axios.put(`/fft/v2/fft-list/${listId}`, requestBody), "Formulation list updated successfully");

export const deleteFftList = (listId, deleteAssociatedLists) =>
 handleApiResponse(
  () => axios.delete(`/fft/v2/fft-list/${listId}?deleteAssociatedLists=${deleteAssociatedLists}`),
  "Formulation list deleted successfully",
 );

export const deleteArchivedFftList = listId =>
 handleApiResponse(() => axios.delete(`/fft/v2/fft-list/${listId}/archived`), "Archived Formulation list deleted successfully");

export const saveOrArchiveFormulation = requestBody =>
 handleApiResponse(() => axios.post(`/fft/v2/fft-list/saveOrArchive`, requestBody), "Formulation list archived successfully");

export const unarchiveFormulation = requestBody =>
 handleApiResponse(() => axios.post(`/fft/v2/fft-list/unarchive`, requestBody), "Formulation list unarchived successfully");
